var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "35.000000pt",
    height: "35.000000pt",
    viewBox: "0 0 35.000000 35.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,35.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 250 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0 -4 -4 -4 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 242 c-1 -10 -16 -13 -52 -10 l-50 3 0 -82 0 -81 43 -14 c46 -16 67 -14 67 8 0 8 10 14 23 14 31 0 47 18 47 52 0 39 -18 35 -22 -4 -2 -25 -8 -33 -23 -33 -18 0 -21 9 -26 80 -3 44 -6 74 -7 67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 230 c0 -15 -7 -20 -24 -20 -14 0 -28 -4 -31 -10 -4 -6 7 -10 24 -10 24 0 31 -4 31 -20 0 -27 12 -25 40 5 l23 25 -23 25 c-28 30 -40 32 -40 5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalir);
export default __webpack_public_path__ + "static/media/salir.fc7e41935c199727cee24a1c21c679ab.svg";
export { ForwardRef as ReactComponent };